import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const IncompleteIndex = lazy(() => import('./incomplete/Index'))
const IDIndex = lazy(() => import('./:id/Index'))
const PreviousIndex = lazy(() => import('../Index'))

export const ExpenseRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route index element={<PreviousIndex />} />
    <Route path='incomplete/*' element={<IncompleteIndex />} />
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
